<template>
  <div class="lp-calculator-call-to-action">
    <div class="lp-cta__content">
      <div class="lp-cta-content__text">
        <slot />
      </div>
      <a :class="`btn btn-${buttonClass} btn-round`"
         :href="buttonLink"
         target="_blank"
         v-if="buttonText != ''"
         @click.prevent="onClick">{{ buttonText }}</a>
    </div>
  </div>
</template>

<script lang="ts">
  declare const DataIntelligenceSubmitScript: any;

  import { defineComponent } from 'vue';

  import { sendInsightReport } from '../helpers/calculators/insight';

  export default defineComponent({
    name: 'CalculatorCallToAction',
    props: {
      buttonLink: {
        type: String,
        required: false,
        default: '#',
      },
      buttonText: {
        type: String,
        required: false,
      },
      buttonClass: {
        type: String,
        required: false,
        default: 'secondary',
      },
      insightName: {
        type: String,
        required: false,
        default: 'Calculator',
      },
    },
    setup(props) {
      const reportClickToDEC = () => {
        DataIntelligenceSubmitScript._client.sentenceClient.writeSentence({
          predicate: 'Clicked',
          object: `${props.insightName} Call to Action`,
        });
      };
      const onClick = () => {
        sendInsightReport(reportClickToDEC);

        if (props.buttonLink) {
          window.location.href = props.buttonLink;
        }
      };
      return { onClick };
    },
  });
</script>

<style scoped></style>
